<script setup lang="ts">
import {computed, ref, watch} from 'vue';

interface Props {
	buttonsPerRow: number;
	totalButtons: number;
	selectedItem?: number;
}

const props = defineProps<Props>();
const activeItem = ref(0);

const row = computed(() => Math.floor(props.selectedItem / props.buttonsPerRow));
const col = computed(() => props.selectedItem % props.buttonsPerRow);
const rows = ref(Math.ceil(props.totalButtons / props.buttonsPerRow));

watch( props, ({ selectedItem } ) => {
	activeItem.value = selectedItem;
} );

</script>

<template>
	<div class="button-group">
		<slot></slot>
	</div>
</template>

<style scoped lang="scss">
.button-group {
	display: grid;
	grid-template-columns: repeat(v-bind('buttonsPerRow'), 1fr);
	position: relative;
	z-index: 1;
	--i: v-bind('activeItem');
	--row-height: calc(100% / v-bind('rows'));

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		z-index:-1;
		width: calc(calc(100% / v-bind('buttonsPerRow')) - 2px);
		height: calc(var(--row-height) - 2px);
		border: 1px solid $brand-blue-dark;
		background-color: $brand-blue-background;
		border-radius: 4px;
		transform: translateX(calc(v-bind('col') * 100%)) translateY(calc(v-bind('row') * 100%));
		will-change: transform;
		transition: transform .2s ease-in-out;
	}

	:deep(.button) {
		position: relative;
		z-index: 2;
	}
}
</style>
